/**
 * Small helpers the catalog surfaces share (BLU-1268). Pure.
 */
import type { CatalogSupplier } from './catalog-picker';

/** Where a catalog supplier opens: the linked supplier's Catalog tab, or the catalog supplier's own page. */
export function catalogHref(row: Pick<CatalogSupplier, 'id' | 'linkedSupplier'>): string {
  return row.linkedSupplier ? `/suppliers/${row.linkedSupplier.id}?tab=catalog` : `/suppliers/catalog/${row.id}`;
}

/** A 2-letter region code in the reader's language; anything else as written; null when empty. */
export function countryName(country: string | null, language: string): string | null {
  const value = country?.trim();
  if (!value) return null;
  if (!/^[A-Za-z]{2}$/.test(value)) return value;
  try {
    return new Intl.DisplayNames([language], { type: 'region' }).of(value.toUpperCase()) ?? value;
  } catch {
    return value;
  }
}
